import type { BoxProps } from '@shopify/polaris';

import { Box } from '@shopify/polaris';

type AriaShadowType =
  | 'shadow-outset-200'
  | 'shadow-drop-outset-100'
  | 'shadow-top-100'
  | 'shadow-bottom-100';
type AriaHeightType = 'height-full';

export interface GBoxProps extends BoxProps {
  ariaShadow?: AriaShadowType;
  ariaHeight?: AriaHeightType;
}

export const GBox = (props: GBoxProps) => {
  return <Box {...props} aria-label={props.ariaShadow} aria-description={props.ariaHeight} />;
};
